import { getData } from '../../_helpers/getData';
import React, { useEffect, useState, Component } from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import Navbar from "./../../components/Navbar";
import TopBar from "./../../components/topbar";
import { domicileService } from "../../_services";
import constant from '../../_config/constant';
import Footer from "./../../layout/footer";



export default function addCategory(props) {
  const [fileData, setFileData] = useState("");
  const getFile = (e) => { setFileData(e.target.files[0]); };

  const [requesting, setRequest] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const decoded = getData();

  function onCreatePost(e) {
    const postData = { cityName : name , pageLink: description, file : fileData };
    e.preventDefault();
    setRequest(true);
    domicileService.add(postData).then(
      objS => { props.history.push("/domicile"); },
      error => { console.log(error) }
    );
  }

  return (
    <div>
      <TopBar user={decoded} title="Add domicile"/>

        <div className="deznav">
          <div className="deznav-scroll">
            <Navbar />
          </div>
        </div>

        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="tab-content">
                  <div className="tab-pane active show" id="All">
                    <form onSubmit={onCreatePost} >
                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          City Name
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="form-control"
                            placeholder="Name"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Page link
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="form-control"
                            placeholder="Page link"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Image
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="file"
                            name="images"
                            onChange={getFile}
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="inputPassword"
                          className="col-sm-2 col-form-label"
                        >
                          &nbsp;
                        </label>
                        <div className="col-sm-10">
                          <button type="submit" className="btn btn-primary">
                            {requesting ? "Please wait ..." : "Add"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
  );
}
